import React, {Fragment, useState} from 'react'
import styled from '@emotion/styled';
import PropTypes from 'prop-types'

const Label = styled.label`
    font-family: "Bebas Neue", cursive;
    color: #fff;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 2.4rem;
    margin-top: 2rem;
    display: block;
`;

const Select = styled.select`
    width: 100%;
    display: block;
    padding: 1rem;
    -webkit-appearance: none;
    border-radius: 10px;
    border: none;
    font-size: 1.2rem;
`

const useMoneda = (label, stateInicial, opciones) => {

    //state de CustomHook
    const [state, actualizarState] = useState(stateInicial);


    const SelectMoneda = () => (
        <Fragment>

            <Label className=""> {label} </Label>
            <Select
                onChange={ e => actualizarState(e.target.value)}
                value={state}
            >

                <option>-Seleccione-</option>
                {opciones.map( opcion => (

                    <option key={opcion.codigo} value={opcion.codigo} >{opcion.nombre}</option>

                ))}

            </Select>
        </Fragment>
    );

    //retornar State, interfaz y func que modifica el state
    return [state, SelectMoneda, actualizarState];

}

useMoneda.propTypes = {
    label: PropTypes.string.isRequired, 
    stateInicial: PropTypes.func.isRequired, 
    opciones: PropTypes.array.isRequired
}

export default useMoneda;